import React from 'react'
import Sidebar from "../components/Sidebar"

import BookingsTable from "../components/BookingsTable"
import "../css/mngbooking.css"

import { Spinner } from "react-bootstrap"
import { useState, useEffect } from "react";

export default function MngBookings() {

  const [loading, setLoading] = useState(false)

  useEffect(() => {
    setLoading(true);
    setTimeout(() => {
      setLoading(false)
    }, 1200);
  }, [])

  return (
    <>
      {
        loading ?

          <div className="loader-screen">
            <Spinner className="loader-icon" animation="border" variant="primary" />
          </div>

          :

          <div className="home">
            <Sidebar />
            <div className="homeContainer">
              <div className="listContainer">

                <BookingsTable />

              </div>
            </div>
          </div>
      }

    </>
  )
}
